interface FlightSegment {
  departureAirport: string;
  departureTime: string;
  arrivalAirport: string;
  arrivalTime: string;
  airline: string;
  flightNumber: string;
  duration: string;
}

interface FlightOffer {
  id: string;
  price: number;
  currency: string;
  airlines: string[];
  segments: FlightSegment[];
  duration: string;
  stops: number;
  bookingUrl: string;
}

interface FlightCardProps {
  flight: FlightOffer;
}

export function FlightCard({ flight }: FlightCardProps) {
  const outbound = flight.segments?.[0];
  const inbound = flight.segments?.length > 1 ? flight.segments[flight.segments.length - 1] : null;

  return (
    <div className="frost-card rounded-lg p-3 text-sm text-ink">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <span className="font-medium">{flight.airlines?.join(", ")}</span>
          <span className="text-xs text-ink-light">
            {flight.stops === 0 ? "Direct" : `${flight.stops} stop${flight.stops > 1 ? "s" : ""}`}
          </span>
        </div>
        <span className="font-bold text-warm">
          {flight.currency} {flight.price?.toFixed(0)}
        </span>
      </div>

      {outbound && (
        <div className="flex items-center gap-3 text-xs text-ink-light">
          <span className="font-medium">{outbound.departureTime}</span>
          <span>{outbound.departureAirport}</span>
          <span className="text-ink-light/60">--</span>
          <span>{outbound.arrivalAirport}</span>
          <span className="font-medium">{outbound.arrivalTime}</span>
          <span className="text-ink-light ml-auto">{flight.duration}</span>
        </div>
      )}

      {inbound && (
        <div className="flex items-center gap-3 text-xs text-ink-light mt-1">
          <span className="font-medium">{inbound.departureTime}</span>
          <span>{inbound.departureAirport}</span>
          <span className="text-ink-light/60">--</span>
          <span>{inbound.arrivalAirport}</span>
          <span className="font-medium">{inbound.arrivalTime}</span>
        </div>
      )}

      {flight.bookingUrl && (
        <a
          href={flight.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-block text-xs text-accent-light hover:text-accent hover:underline font-medium"
        >
          Book this flight
        </a>
      )}
    </div>
  );
}
